import React, { useState } from 'react';
import { Container, AppBar, TextField, Tooltip, Button, Modal, Box, Typography, Toolbar, Paper } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AddBank() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  let navigate = useNavigate();
  const [bankName, setBankName] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success'); // 'success' or 'error'
  const [accountNo, setAccountNo] = useState('');
  const [openingBalance, setOpeningBalance] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);

  const handleSave = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Bank`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          bankName: bankName,
          accountNo: accountNo,
          openingBalance: 0
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        console.log('Bank details:', responseData);
        setLoadingBarProgress(100);

        // Check status field or keywords in message for failures
        const errorKeywords = ['already exist', 'failed', 'error', 'unable', 'cannot'];
        const messageHasError = errorKeywords.some(k => responseData.msg && responseData.msg.toLowerCase().includes(k));

        if (responseData.status && responseData.status.toLowerCase().includes('failed')) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else if (messageHasError) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else {
          setModalType('success');
          setModalMessage(responseData.msg || 'Payment details have been added successfully.');
        }

        setModalOpen(true);
        if (!messageHasError && (!responseData.status || !responseData.status.toLowerCase().includes('failed'))) {
          setBankName('');
          setAccountNo('');
          setOpeningBalance('');
        }
      } else {
        // alert('Failed to fetch bank details');
        setSnackbarMessage('Failed to fetch bank details');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
      }
    } catch (error) {
      // alert('API request error:', error);
      setSnackbarMessage('API request error:', error);
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
    }
  };

  const handleCancel = () => {
    // Add logic to handle cancel action
    setBankName('');
    setAccountNo('');
    setOpeningBalance('');
  };

  return (
    <Container mt={4}>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add Payment
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
        <div>
          <TextField
            label="Payment Method"
            variant="outlined"
            fullWidth
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Account No"
            variant="outlined"
            fullWidth
            value={accountNo}
            onChange={(e) => setAccountNo(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Opening Balance"
            variant="outlined"
            fullWidth
            value={openingBalance}
            onChange={(e) => setOpeningBalance(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!bankName || !accountNo ? "Please fill all fields" : ""} arrow>
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                sx={{ mr: 2 }}
                disabled={!bankName || !accountNo}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: modalType === 'success' ? '#0B1F40' : '#d32f2f', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'success' ? 'Success ✅' : 'Error ❌'}
            </Typography>
          </Box>

          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType === 'success') {
                    navigate(-1); // go back after closing modal
                  }
                }}
                variant="contained"
                color={modalType === 'success' ? 'primary' : 'error'}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>

  );
}

export default AddBank;
